import { useState } from "react";
import Button from "@material-ui/core/Button";
import { generatePainFile } from "../../../../utilities/generatePainFile";

const SendBackPainButton = ({ getSelected }) => {
  const [error, setError] = useState("");

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() =>
          generatePainFile(getSelected(), "/send-back-pain", setError)
        }
        style={{ marginRight: "3px" }}
      >
        Generate pain file (will exlude AML Warings)
      </Button>
      <br />
      <div style={{ color: "red" }}>{error}</div>
    </div>
  );
};

export default SendBackPainButton;
